import {translateServiceClient} from './service'
import {
    ReadingFileRequest,
    UploadRequest,
    FileListRequest,
    FileStatus,
    DeleteFileRequest,
    StatusRequest,
    DocumentRequest,
    UploadCountRequest,
    ReadDocumentRequest,
    UploadTipRequest,
    SubmitRequest,
    QueryDocumentRequest,
    PayRequest,
    ParentPowerRequest,
    TransTextRequest,
    UploadConvertPDFRequest,
    SubmitConvertRequest,
    CheckRoamingRequest,
    ProDocumentRequest,
    DetailRequest,
    SendEmailRequest,
    GetEmailRequest,
    GetCarouselRequest,
    GetActivityNoticeRequest,
    UploadTmpRequest,
    DelTmpRequest,
    TransTmpRequest,
    SelectTmpRequest,
    GetMedicineDictRequest,
    SelectMedicineDictSpecRequest,
    AiSendRequest,
    AiSessionPageRequest,
    DelAiSessionRequest,
    CreateAiSessionRequest,
    AiHistoryPageRequest,
    TransTextHistoryRequest,
    DeleteAllRequest,
    DeleteOneRequest
} from '../../../api/translateService_pb'
let aiHistoryPageRequest = new AiHistoryPageRequest();
let delAiSessionRequest = new DelAiSessionRequest();
let aiSessionPageRequest = new AiSessionPageRequest();
let aiSendRequest = new AiSendRequest();
let getMedicineDictRequest = new GetMedicineDictRequest();
let getCarouselRequest = new GetCarouselRequest();
let getActivityNoticeRequest = new GetActivityNoticeRequest();
let sendEmailRequest = new SendEmailRequest();
let detailRequest = new DetailRequest();
let proDocumentRequest = new ProDocumentRequest();
let checkRoamingRequest = new CheckRoamingRequest();
let submitConvertRequest = new SubmitConvertRequest();
let uploadConvertPDFRequest = new UploadConvertPDFRequest();
const transTextRequest = new TransTextRequest();
const parentPowerRequest = new ParentPowerRequest();
const payRequest = new PayRequest();
const uploadTipRequest = new UploadTipRequest();
const uploadRequest = new UploadRequest();
const fileListRequest = new FileListRequest();
const fileStatus = FileStatus;
const deleteFileRequest = new DeleteFileRequest();
const readingFileRequest = new ReadingFileRequest();
const statusRequest = new StatusRequest();
const documentRequest = new DocumentRequest();
const uploadCountRequest = new UploadCountRequest();
const readDocumentRequest = new ReadDocumentRequest();
const submitRequest = new SubmitRequest();
let queryDocumentRequest = new QueryDocumentRequest();
let getEmailRequest = new GetEmailRequest();
let uploadTmpRequest = new UploadTmpRequest();
let delTmpRequest = new DelTmpRequest();
let transTmpRequest = new TransTmpRequest();
let selectTmpRequest = new SelectTmpRequest();
let selectMedicineDictSpecRequest = new SelectMedicineDictSpecRequest();
let createAiSessionRequest = new CreateAiSessionRequest();
let transTextHistoryRequest = new TransTextHistoryRequest();
let deleteAllRequest = new DeleteAllRequest();
let deleteOneRequest = new DeleteOneRequest();
export {
    aiHistoryPageRequest,
    createAiSessionRequest,
    delAiSessionRequest,
    aiSessionPageRequest,
    aiSendRequest,
    getCarouselRequest,
    getActivityNoticeRequest,
    getEmailRequest,
    detailRequest,
    checkRoamingRequest,
    queryDocumentRequest,
    submitRequest,
    uploadTipRequest,
    translateServiceClient,
    fileListRequest,
    uploadRequest,
    fileStatus,
    deleteFileRequest,
    readingFileRequest,
    statusRequest,
    documentRequest,
    uploadCountRequest,
    readDocumentRequest,
    payRequest,
    parentPowerRequest,
    transTextRequest,
    uploadConvertPDFRequest,
    submitConvertRequest,
    FileListRequest,
    proDocumentRequest,
    sendEmailRequest,
    uploadTmpRequest,
    delTmpRequest,
    transTmpRequest,
    selectTmpRequest,
    getMedicineDictRequest,
    selectMedicineDictSpecRequest,
    transTextHistoryRequest,
    deleteAllRequest,
    deleteOneRequest
}
